<template>
  <form @submit.prevent="filterTopUps()">
    <div class="row">
      <div class="col-lg-2 col-md-4">
        <base-input
          type="text"
          :label="$t('topUp.details.merchant_reference')"
          placeholder=""
          v-model="merchantReference"
          addon-left-icon="tim-icons icon-light-3"
        >
        </base-input>
      </div>
      <div class="col-lg-2 col-md-4">
        <base-input
          type="number"
          :label="$t('topUp.filterForm.amountLbl')"
          placeholder=""
          v-model.number="amount"
          step="0.01"
          addon-left-icon="tim-icons icon-coins"
        >
        </base-input>
      </div>
      <div class="col-lg-2 col-md-4 pl-0">
        <base-input
          :label="$t('topUp.filterForm.dateLbl')">
          <template>
            <el-date-picker
              v-model="date"
              type="date"
              unlink-panels
              align="center"
              :clearable="false"
              :start-placeholder="$t('topUp.filterForm.fromDatePlaceholder')"
              :end-placeholder="$t('topUp.filterForm.toDatePlaceholder')">
              <template slot="range-separator">
                {{$t('topUp.filterForm.toDate')}}
              </template>
            </el-date-picker>
          </template>
        </base-input>
      </div>
      <div class="col-lg-4 col-md-6 pl-0 align-self-end">
        <div class="form-group">
          <base-button
            :loading="loading"
            native-type="submit"
            type="default"
            class="btn-fill mb-0"
          ><i class="tim-icons icon-light-3 pr-2"/> {{ $t('topUp.filterForm.actionBtn') }}
          </base-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

  import {DatePicker} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'top-ups-filter-form',
    components: {
      [DatePicker.name]: DatePicker,
    },
    props: {
      filterDetails: {
        type: Object,
        required: false,
      },
    },
    methods: {
      ...mapActions(['LoadTopUps']),
      filterTopUps() {
        let date = null;
        if (this.date) {
          date = this.$options.filters.dateOnly(this.date)
        }
        var apiQuery = {
          date: date,
          amount: Math.round(this.amount * 100),
          merchantReference: this.merchantReference,
        }
        this.LoadTopUps(apiQuery)
      }
    },
    computed: {
      ...mapState({
        loading: state => state.top_ups.loading,
      }),
    },
    data() {
      return {
        date: new Date(),
        amount: 2.00,
        merchantReference: ""
      };
    },
    mounted() {
      if (this.filterDetails) {
        this.date = new Date(this.filterDetails.date)
        this.amount = this.filterDetails.amount / 100
        this.merchantReference = this.filterDetails.merchantReference
      }
    }
  };
</script>
<style>
</style>
